enum ColorClass {
  BackgroundOverlay = "colorBackgroundOverlay",
  BrightPurple = "colorBrightPurple",
  Dimmer = "colorDimmer",
  Error = "colorError",
  Green = "colorGreen",
  Ghost = "colorGhost",
  LightBlue = "colorLightBlue",
  LightPink = "colorLightPink",
  LightPurple = "colorLightPurple",
  LightPurpleHover = "colorLightPurpleHover",
  Navy = "colorNavy",
  NavyHover = "colorNavyHover",
  Pink = "colorPink",
  Primary = "colorPrimary",
  Purple = "colorPurple",
  Red = "colorRed",
  RedHover = "colorRedHover",
  Secondary = "colorSecondary",
  Shader = "colorShader",
  Tertiary = "colorTertiary",
  White = "colorWhite",
  Yellow = "colorYellow",
  PhantomPurple = "colorPhantomPurple",
}

export default ColorClass;
